import React, { Component } from 'react';
import { connect } from 'react-redux';
import { HighchartsProvider } from 'react-highcharts-wrapper';

import NorthStarMetricsV2View from 'components/organisms/analytics/NorthStarMetricsV2View';
import { fetchAnalyticsV2 } from 'services/analytics/duck';
import { setHighchartsOptions } from 'helpers/charts';

class AnalyticsDataContainer extends Component {
    componentDidMount() {
        this.props.fetchAnalyticsV2();
    }
    render() {
        return <HighchartsProvider executeFuncs={[setHighchartsOptions]}>
            <NorthStarMetricsV2View analytics={this.props.analytics} />
        </HighchartsProvider>;
    }
}

const mapStateToProps = state => ({
    analytics: state.analytics
});

export default connect(mapStateToProps, {
    fetchAnalyticsV2
})(AnalyticsDataContainer);



// WEBPACK FOOTER //
// ./src/containers/AnalyticsDataContainer.js